import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink, Route, Switch, withRouter} from 'react-router-dom';

import {Menu, Sidebar} from 'semantic-ui-react';

import ScenePlanet from '../../scene-planet';
import Reddit from '../../client-reddit';

class PortfolioSidebar extends Component {

    shouldComponentUpdate({location: {
            pathname
        }, visible}) {
        return pathname !== this.props.location.pathname || visible !== this.props.visible;
    }

    render() {
        // console.log('PortfolioSidebar render');
        const {routes, visible} = this.props;
        return <Switch>
            <Route path={routes.clientReddit}>
                <Reddit.Sidebar visible={visible}/>
            </Route>
            <Route path={routes.scenePlanet}>
                <ScenePlanet.Sidebar visible={visible}/>
            </Route>
            <Route>
                <Sidebar as={Menu} vertical={true} inverted={true} animation='overlay' visible={visible}>
                    <Menu.Item as={NavLink} to={`${routes.portfolio}/notifications`} name='Notifications'/>
                    <Menu.Item as={NavLink} to={routes.clientReddit} name='Reddit Client'/>
                    <Menu.Item as={NavLink} to={routes.scenePlanet} name='Planet Scene'/>
                </Sidebar>
            </Route>
        </Switch>;
    }
}

const connectedSidebar = connect(({routes}) => ({routes}))(PortfolioSidebar);
export default withRouter(connectedSidebar);


// WEBPACK FOOTER //
// ./src/apps/portfolio/components/Sidebar.js